import { Button, Middle, Spacing, Text, modularScale } from "@ottatech/design";
import styled from "styled-components";
import { useMutation } from "@apollo/client";

import { Link } from "components/Link";
import { ConvertAccountDocument, CurrentUserDocument } from "schema";
import { handleMutationError } from "utils/error";

const Container = styled.div`
  overflow-y: scroll;
  display: flex;
  margin-top: ${modularScale(10)};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  p {
    text-align: center;
  }
`;

export function Recruiter(): React.ReactElement {
  const [mutation, { loading }] = useMutation(ConvertAccountDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: CurrentUserDocument,
      },
    ],
    onError: handleMutationError,
  });

  return (
    <Container>
      <Middle maxWidth={600}>
        <Spacing size={-1}>
          <Text as="h2" bold align="center" size={3}>
            Oops!
          </Text>
          <Text align="center">
            You can&apos;t see this page because you are logged in as a
            recruiter.
          </Text>
          <Text align="center">
            You can convert this account to a candidate account by clicking
            below.
          </Text>
          <Button
            level="primary"
            disabled={loading}
            onClick={async () => mutation()}
          >
            Convert to candidate account
          </Button>
          <Button as="a" level="secondary" href="https://hire.otta.com">
            Return to Hire with Otta
          </Button>
          <Link to="/logout">Log out</Link>
        </Spacing>
      </Middle>
    </Container>
  );
}
